import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { emptyArray, emptyObject } from 'ui-components/default-props/empty';
import { FormattedMessage } from 'react-intl';
import { LOCATION_OPTIONS } from '../constants';
import { testId } from 'ui-components/services/testid-service';

import messages from '../messages';
import style from './style.module.less';

const PickupReminder = ({ serviceCounts = emptyArray, todaysPickup = emptyObject }) => {
  const selectedLocation = LOCATION_OPTIONS.find((o) => o.apiValue === todaysPickup.pickupLocation);
  const renderServiceCounts = useCallback((service) => {
    return (
      <>
        <div className={style['reminder-label']}>{service.name}</div>
        <div key={service.key} className={style['reminder-value']} {...testId('reminder-count')}>
          <span>{service.count}</span>
        </div>
      </>
    );
  }, []);

  return (
    <div className={style['pickup-reminder']}>
      <p className={style['reminder-text']}>
        <FormattedMessage {...messages.reminderText} />
      </p>
      <div className={style['reminder-wrapper']}>
        <div className={style['reminder-services']}>{serviceCounts.map(renderServiceCounts)}</div>
        <div className={style['reminder-details']}>
          <div className={style['reminder-label']}>
            <FormattedMessage {...messages.totalWeightPickupLabel} />
          </div>
          <div className={style['reminder-value']}>{todaysPickup.totalWeight}</div>
          <div className={style['reminder-label']}>
            <FormattedMessage {...messages.pickupLocationPickupLabel} />
          </div>
          <div className={style['reminder-value']}>
            <FormattedMessage {...selectedLocation.displayName} />
          </div>
          <div className={style['reminder-label']}>
            <FormattedMessage {...messages.specialInstructionPickupLabel} />
          </div>
          <div className={style['reminder-value']}>
            <span className={style['reminder-instructions']}>{todaysPickup.specialInstruction}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

PickupReminder.propTypes = {
  serviceCounts: PropTypes.array,
  todaysPickup: PropTypes.shape({
    totalWeight: PropTypes.number,
    pickupLocation: PropTypes.oneOf(LOCATION_OPTIONS.map((o) => o.apiValue)),
    specialInstruction: PropTypes.string,
  }),
};

export default PickupReminder;
